<template>
    <div class="nadlan-breadcrumbs mobile-active">
        <div
            class="location"
            v-if="
                checkRouteType != null &&
                ($store.state.setlCode != null ||
                    $store.state.neighborhoodId != null)
            "
        >
            <a
                v-if="checkRouteType == 'address'"
                class="locationLink"
                :href="'/?view=address&id=' + $store.state.addressId + '&page=deals'"
                >{{ checkAddress }},
            </a>
            <a
                v-if="checkRouteType == 'street'"
                class="locationLink"
                :href="'/?view=street&id='  + $store.state.streetCode + '&page=deals'"
                >{{ checkAddress }},
            </a>
            <a
                v-if="checkRouteType == 'kparcel_all'"
                class="locationLink"
                :href="'/?view=kparcel_all&id=' + $store.state.kParcel + '&page=deals'"
            >
                גוש חלקה {{ checkAddress }},
            </a>
            <a
                v-if="$store.state.neighborhoodName != null && $store.state.neighborhoodName != ''"
                class="locationLink"
                :href="
                    '/?view=neighborhood&id=' +
                    $store.state.neighborhoodId +
                    '&page=deals'
                "
                >{{ $store.state.neighborhoodName }},
            </a>
            <a
                class="locationLink"
                :href="
                    '/?view=settlement&id=' + $store.state.setlCode + '&page=deals'
                "
                >{{ $store.state.settlementName }}
            </a>

            <div v-if="checkRouteType == 'kparcel_all'" class="type">
                גוש חלקה
            </div>
            <div v-if="checkRouteType == 'street'" class="type">רחוב</div>
            <div v-if="checkRouteType.startsWith('settlement')" class="type">
                ישוב
            </div>
            <div v-if="checkRouteType.startsWith('neighborhood')" class="type">
                שכונה
            </div>
        </div>
        <div
            v-if="
                checkRouteType != null &&
                ($store.state.setlCode != null ||
                    $store.state.neighborhoodId != null)
            "
        >
            <button class="shareIconWrap" @click="tuggleShare">
                <svg
                    width="16px"
                    height="16px"
                    viewBox="0 0 16 16"
                    version="1.1"
                    class="icon"
                >
                    <title>שיתוף</title>
                    <g
                        id="share-16-copy"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                    >
                        <g id="Group">
                            <circle id="oval" fill="#02234B" cx="4" cy="3" r="2"></circle>
                            <circle
                                id="oval"
                                fill="#02234B"
                                cx="12"
                                cy="8"
                                r="2"
                            ></circle>
                            <circle
                                id="oval"
                                fill="#02234B"
                                cx="4"
                                cy="13"
                                r="2"
                            ></circle>
                            <polyline
                                id="path"
                                stroke="#02234B"
                                points="4 3 12 8 4 13"
                            ></polyline>
                        </g>
                    </g>
                </svg>
            </button>
        </div>
        <div class="shareButtonsDesktop">
            <button
                @click="mixin_share('facebook')"
                title="שתף בפייסבוק"
                aria-label="facebook"
                class="react-share__ShareButton"
                style="
                    background-color: transparent;
                    border: none;
                    padding: 0px;
                    font: inherit;
                    color: inherit;
                    cursor: pointer;
                "
            >
                <svg viewBox="0 0 64 64" width="25" height="25">
                    <circle cx="32" cy="32" r="31" fill="#3b5998"></circle>
                    <path
                        d="M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z"
                        fill="white"
                    ></path>
                </svg>
            </button>
            <span title="שתף בטוויטר">
                <button
                    @click="mixin_share('twitter')"
                    aria-label="twitter"
                    class="react-share__ShareButton"
                    style="
                        background-color: transparent;
                        border: none;
                        padding: 0px;
                        font: inherit;
                        color: inherit;
                        cursor: pointer;
                    "
                >
                    <svg viewBox="0 0 64 64" width="25" height="25">
                        <circle cx="32" cy="32" r="31" fill="#00aced"></circle>
                        <path
                            d="M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z"
                            fill="white"
                        ></path>
                    </svg>
                </button>
            </span>
            <span title="שתף בוואטסאפ">
                <button
                    @click="mixin_share('whatsapp')"
                    aria-label="whatsapp"
                    class="react-share__ShareButton"
                    style="
                        background-color: transparent;
                        border: none;
                        padding: 0px;
                        font: inherit;
                        color: inherit;
                        cursor: pointer;
                    "
                >
                    <svg viewBox="0 0 64 64" width="25" height="25">
                        <circle cx="32" cy="32" r="31" fill="#25D366"></circle>
                        <path
                            d="m42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915"
                            fill="white"
                        ></path>
                    </svg>
                </button>
            </span>
            <span title="שתף בטלגרם">
                <button
                    @click="mixin_share('telegram')"
                    aria-label="telegram"
                    class="react-share__ShareButton"
                    style="
                        background-color: transparent;
                        border: none;
                        padding: 0px;
                        font: inherit;
                        color: inherit;
                        cursor: pointer;
                    "
                >
                    <svg viewBox="0 0 64 64" width="25" height="25">
                        <circle cx="32" cy="32" r="31" fill="#37aee2"></circle>
                        <path
                            d="m45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957"
                            fill="white"
                        ></path>
                    </svg>
                </button>
            </span>
            <button
                title="שתף במייל"
                @click="mixin_share('email')"
                aria-label="email"
                class="react-share__ShareButton"
                style="
                    background-color: transparent;
                    border: none;
                    padding: 0px;
                    font: inherit;
                    color: inherit;
                    cursor: pointer;
                "
            >
                <svg viewBox="0 0 64 64" width="25" height="25">
                    <circle cx="32" cy="32" r="31" fill="#7f7f7f"></circle>
                    <path
                        d="M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z"
                        fill="white"
                    ></path>
                </svg>
            </button>
        </div>
        <div class="shareButtons" v-if="showShare == true">
            <button
                title="שתף בפייסבוק"
                @click="mixin_share('facebook')"
                aria-label="facebook"
                class="react-share__ShareButton"
                style="
                    background-color: transparent;
                    border: none;
                    padding: 0px;
                    font: inherit;
                    color: inherit;
                    cursor: pointer;
                "
            >
                <svg viewBox="0 0 64 64" width="25" height="25">
                    <circle cx="32" cy="32" r="31" fill="#3b5998"></circle>
                    <path
                        d="M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z"
                        fill="white"
                    ></path>
                </svg>
            </button>
            <span title="שתף בטוויטר">
                <button
                    @click="mixin_share('twitter')"
                    aria-label="twitter"
                    class="react-share__ShareButton"
                    style="
                        background-color: transparent;
                        border: none;
                        padding: 0px;
                        font: inherit;
                        color: inherit;
                        cursor: pointer;
                    "
                >
                    <svg viewBox="0 0 64 64" width="25" height="25">
                        <circle cx="32" cy="32" r="31" fill="#00aced"></circle>
                        <path
                            d="M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z"
                            fill="white"
                        ></path>
                    </svg>
                </button>
            </span>
            <span title="שתף בוואטסאפ">
                <button
                    @click="mixin_share('whatsapp')"
                    aria-label="whatsapp"
                    class="react-share__ShareButton"
                    style="
                        background-color: transparent;
                        border: none;
                        padding: 0px;
                        font: inherit;
                        color: inherit;
                        cursor: pointer;
                    "
                >
                    <svg viewBox="0 0 64 64" width="25" height="25">
                        <circle cx="32" cy="32" r="31" fill="#25D366"></circle>
                        <path
                            d="m42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915"
                            fill="white"
                        ></path>
                    </svg>
                </button>
            </span>
            <span title="שתף בטלגרם">
                <button
                    @click="mixin_share('telegram')"
                    aria-label="telegram"
                    class="react-share__ShareButton"
                    style="
                        background-color: transparent;
                        border: none;
                        padding: 0px;
                        font: inherit;
                        color: inherit;
                        cursor: pointer;
                    "
                >
                    <svg viewBox="0 0 64 64" width="25" height="25">
                        <circle cx="32" cy="32" r="31" fill="#37aee2"></circle>
                        <path
                            d="m45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957"
                            fill="white"
                        ></path>
                    </svg>
                </button>
            </span>
            <button
                @click="mixin_share('email')"
                title="שתף במייל"
                aria-label="email"
                class="react-share__ShareButton"
                style="
                    background-color: transparent;
                    border: none;
                    padding: 0px;
                    font: inherit;
                    color: inherit;
                    cursor: pointer;
                "
            >
                <svg viewBox="0 0 64 64" width="25" height="25">
                    <circle cx="32" cy="32" r="31" fill="#7f7f7f"></circle>
                    <path
                        d="M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z"
                        fill="white"
                    ></path>
                </svg>
            </button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'BreadCrumbs',
    data() {
        return {
            showShare: false,   
        }
    },
    methods: {
        tuggleShare() {
			this.showShare = !this.showShare;
		},
    },
    computed: {
        checkRouteType() {
			//var st = this.$route.name;
			var st = this.$route.query.view;
			return st;
		},
        checkAddress() {
			// if (this.$store.state.addrName != null) {
			// 	return this.$store.state.addrName;
			// }
			if (this.checkRouteType == "kparcel_all") {
				//return this.$route.params.kParcel;
				return this.$route.query.id;
			}

			var addrs = [];
			var streets = {};
			this.$parent.selectedDeals.forEach(function (deal) {
			if (!addrs.includes(deal.address)) {
					var strName = deal.address.replace(/\d+$/, "").trim();
					var houseNum = deal.address.replace(strName, "").trim();
					//if (!streets.hasOwnProperty(strName)) {
					if (Object.keys(streets).includes(strName) == false) {
						streets[strName] = [houseNum];
					}
					if (!streets[strName].includes(houseNum)) {
						streets[strName].push(houseNum);
					}
					addrs.push(deal.address);
				}
			});
			//

			if (this.checkRouteType == "address") {
				var addrsStr = "";

				var entries = Object.entries(streets);
				// collect all house numbers for each street
				entries.forEach(function (entry) {
					var streetName = entry[0];
					var houseNums = entry[1];
					//sort house numbers
					houseNums.sort(function (a, b) {
						return a - b;
					});
					var houseNumsStr = houseNums.join(", ");
					addrsStr += streetName + " " + houseNumsStr + ", ";
				});

				// remove last comma
				addrsStr = addrsStr.replace(/,\s*$/, "");
                if (this.$store.state.addrName != null && addrsStr == "") {
                    return this.$store.state.addrName;
                }
				return addrsStr;
			}
			else if (this.checkRouteType == "street") {
				if (addrs.length > 0) {
					var firstAddr = addrs[0];

					var streetName = firstAddr.replace(/\d+$/, "");
					return streetName;
				}
				else {
					return this.$store.state.streetName;
				}
			}
			else{
				return "";
			}

			//});
		},
    },
}
</script>